import analysisMapModule from "./analysisMapModule"
import server from "../server"

analysisMapModule.service("analysisMapService", [
    "$http",
    ($http) => {

        const markersServiceUrl = server.getServiceUrl("analysisMapMarkers")
        const optimizeServiceUrl = server.getServiceUrl("analysisMapOptimize")
        const optimizeServiceWithRestrictionsUrl = server.getServiceUrl("analysisMapOptimizeWithRestrictions")
        const ordersDetailsServiceUrl = server.getServiceUrl("analysisMapOrdersDetails")

        return {
            doOptimize: doOptimize,
            doOptimizeWithRestrictions: doOptimizeWithRestrictions,
            findMarkers: findMarkers,
            getOrdersDetails: getOrdersDetails
        }

        function doOptimize(deliveryUnitsIds) {
            return $http.post(optimizeServiceUrl, deliveryUnitsIds)
        }

        function doOptimizeWithRestrictions(deliveryUnitsIds, restrictions) {
            return $http.post(optimizeServiceWithRestrictionsUrl, {
                deliveryUnitsIds: deliveryUnitsIds,
                restrictions: restrictions
            })
        }

        function findMarkers(ordersSourceIds) {
            return $http.post(markersServiceUrl, ordersSourceIds).then((response) => response.data)
        }

        function getOrdersDetails(ordersSourceIds) {
            return $http.post(ordersDetailsServiceUrl, ordersSourceIds).then((response) => response.data)
        }
    }])
